import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';

import { LIKELY_TO_SELL_RANK_TO_LIKELIHOOD } from '../filters/constants';
import { Badge, Col, Row } from 'react-bootstrap-5';
import { faFire, faTemperatureFull, faTemperatureHalf } from '@fortawesome/pro-regular-svg-icons';
import { type InsightsPropertyScores, type LikelyToSellRefi } from 'bundles/connect/types';

type ScoreBadgesProps = {
  scores: InsightsPropertyScores;
}

type ScoreBadgeProps = {
  label: string;
  score: LikelyToSellRefi | null;
}

export default function ScoreBadges({ scores }: ScoreBadgesProps) {
  const likelyToSell = scores?.likelyToSell;
  const likelyToRefi = scores?.likelyToRefi;

  if (!likelyToSell?.restricted && !likelyToSell?.rank && !likelyToRefi?.rank && !likelyToRefi?.restricted) return null;

  return (
    <Row className="d-flex g-1">
      <ScoreBadge label="Sell" score={likelyToSell} />
      <ScoreBadge label="Refi" score={likelyToRefi} />
    </Row>
  );
}

export function ScoreBadge({ label, score }: ScoreBadgeProps) {
  let badge: React.JSX.Element | null = null;

  const getIcon = (rank: number) => {
    switch (rank) {
    case 1:
      return <FontAwesomeIcon color="#D18624" icon={faTemperatureHalf} />;
    case 2:
      return <FontAwesomeIcon color="#B23A3D" icon={faTemperatureFull} />;
    case 3:
      return <FontAwesomeIcon color="#E20067" icon={faFire} />;
    }
  };

  if (!score) return null;

  if (score.restricted) badge = (
    <div
      className="d-flex align-items-center gap-2 py-1 px-2 fw-bold small"
      style={{ backgroundColor: '#7422ce', color: '#f2eafd' }}
    >
      <FontAwesomeIcon icon={faLock} />
      Unlock Likely {label} Score
    </div>
  );

  if (LIKELY_TO_SELL_RANK_TO_LIKELIHOOD[score.rank]) badge = (
    <Badge bg="" className="text-body fw-normal rounded muted" style={{ fontSize: '0.875rem' }}>
      {getIcon(score.rank)}
      {LIKELY_TO_SELL_RANK_TO_LIKELIHOOD[score.rank]} To {label}
    </Badge>
  );

  return badge ? <Col xs="auto">{badge}</Col> : null;
}
